import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';

const getNetworkDetails = (error: Error) => {
  const details: any = {};

  // Axios error details
  if (axios.isAxiosError(error)) {
    details.requestUrl = error.config?.url;
    details.requestMethod = error.config?.method?.toUpperCase();
    details.statusCode = error.response?.status;
    details.statusText = error.response?.statusText;
    details.errorCode = error.code;
    details.errorName = error.name;
  }

  // Network connectivity details
  if (typeof navigator !== 'undefined') {
    details.connectionType = (navigator as any).connection?.effectiveType;
    details.connectionDownlink = (navigator as any).connection?.downlink;
  }

  return details;
};

const datadogLogger = (
  error: Error,
  context: {
    description: string;
    errorSource: string;
    [key: string]: any;
  },
) => {
  datadogRum.addError(error, {
    ...getNetworkDetails(error),
    ...context,
  });
};

export default datadogLogger;
